import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { publicRouteElements } from "./PublicRoutes";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSessions from "./pages/admin/AdminSessions";
import AdminParticipants from "./pages/admin/AdminParticipants";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminPortfolio from "./pages/admin/AdminPortfolio";
import AdminStudioRefs from "./pages/admin/AdminStudioRefs";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminCalendrier from "./pages/admin/AdminCalendrier";
import AdminPromo from "./pages/admin/AdminPromo";
import AdminCalendarSync from "./pages/admin/AdminCalendarSync";
import AdminKitImprimes from "./pages/admin/AdminKitImprimes";
import AdminDevis from "./pages/admin/AdminDevis";
import AdminLiensPartage from "./pages/admin/AdminLiensPartage";
import AdminServicesImages from "./pages/admin/AdminServicesImages";
import AdminWaitlist from "./pages/admin/AdminWaitlist";
import AdminTemoignages from "./pages/admin/AdminTemoignages";
import AdminGifts from "./pages/admin/AdminGifts";
import AdminMarketing from "./pages/admin/AdminMarketing";
import { PageSEO } from "./components/PageSEO";
import AdminSiteSettings from "./pages/admin/AdminSiteSettings";
import AdminProspection from "./pages/admin/AdminProspection";
import AdminPdfShop from "./pages/admin/AdminPdfShop";

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes/>
    </BrowserRouter>
  );
}

export function AppRoutes() {
  return <>
      <PageSEO/>
      <Routes>
        {/* Admin (no public layout) */}
        <Route path="/admin/login" element={<AdminLogin/>}/>
        <Route path="/admin" element={<AdminLayout/>}>
          <Route index element={<Navigate to="dashboard" replace/>}/>
          <Route path="dashboard" element={<AdminDashboard/>}/>
          <Route path="sessions" element={<AdminSessions/>}/>
          <Route path="participants" element={<AdminParticipants/>}/>
          <Route path="messages" element={<AdminMessages/>}/>
          <Route path="portfolio" element={<AdminPortfolio/>}/>
          <Route path="studio-refs" element={<AdminStudioRefs/>}/>
          <Route path="reservations" element={<AdminBookings/>}/>
          <Route path="calendrier" element={<AdminCalendrier/>}/>
          <Route path="promo-codes" element={<AdminPromo/>}/>
          <Route path="calendar-sync" element={<AdminCalendarSync/>}/>
          <Route path="kit-imprimes" element={<AdminKitImprimes/>}/>
          <Route path="devis" element={<AdminDevis/>}/>
          <Route path="liens-partage" element={<AdminLiensPartage/>}/>
          <Route path="services-images" element={<AdminServicesImages/>}/>
          <Route path="waitlist" element={<AdminWaitlist/>}/>
          <Route path="temoignages" element={<AdminTemoignages/>}/>
          <Route path="cartes-cadeau" element={<AdminGifts/>}/>
          <Route path="marketing" element={<AdminMarketing/>}/>
          <Route path="prospection" element={<AdminProspection/>}/>
          <Route path="boutique-pdf" element={<AdminPdfShop/>}/>
          <Route path="site" element={<AdminSiteSettings/>}/>
        </Route>

        {publicRouteElements()}
      </Routes>
    </>;
}
